import { useBusinessDocumentSettingService } from '@/context/services/business_document_setting';
import { useTranslation } from '@/i18n';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useCallback, useState } from 'react';

export const useSubmitBusinessDocumentSetting = () => {
  const { t } = useTranslation();
  const notify = useToastAPI();
  const { isEnabled, enableSetting, disableSetting } =
    useBusinessDocumentSettingService();
  const [isLoading, setIsLoading] = useState(false);

  const submitEnableSetting = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await enableSetting();
      if (result.status === 'success') {
        notify.success({
          title: t('business_document_setting_update_success'),
          duration: 5,
        });
        return true;
      } else {
        notify.error({
          title: t('business_document_setting_update_error'),
          duration: 0,
        });
        return false;
      }
    } catch {
      notify.error({
        title: t('business_document_setting_update_error'),
        duration: 0,
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  }, [enableSetting, notify, t]);

  const submitDisableSetting = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await disableSetting();
      if (result.status === 'success') {
        notify.success({
          title: t('business_document_setting_update_success'),
          duration: 5,
        });
        return true;
      } else {
        notify.error({
          title: t('business_document_setting_update_error'),
          duration: 0,
        });
        return false;
      }
    } catch {
      notify.error({
        title: t('business_document_setting_update_error'),
        duration: 0,
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  }, [disableSetting, notify, t]);

  return {
    isEnabled,
    submitEnableSetting,
    submitDisableSetting,
    isLoading,
  };
};
